import React, { useState, useEffect } from 'react';
import { Carousel, Input, Empty } from 'antd';
import './style.css';
import { SearchOutlined } from '@ant-design/icons';
import DownFinger from '../../assets/images/png/up-sign.png';
import LineButton from '../../components/line-button';
import FacebookButton from '../../components/facebook-button';
import ProductCard from '../../components/product-card';
import { slide_images } from '../../utils/schemas';
import { pin_products } from '../../utils/schemas';
import { highlight_products } from '../../utils/schemas';

import ApiServices from '../../utils/apiServices';
import Loading from '../../components/loading';
import { useNavigate } from 'react-router-dom';


const leftSectionStyle = {
    flex: 1,
    marginBottom: 0,
};

const rightSectionStyle = {
    flex: 1,
    width: '100%',
    maxWidth: "100vw",
    aspectRatio: "19 / 8", // Maintains the 19:8 aspect ratio
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden"

};

const inputStyle = {
    width: '100%',
    padding: '10px 15px',
    borderRadius: '30px',
    border: '3px solid #fd0088',
    fontSize: '16px',

};

const linkStyle = {
    fontSize: '16px',
    color: '#ff0080',
    cursor: 'pointer',
    textDecoration: 'none',
};

export default function Home() {

    const { getList } = ApiServices();


    const navigate = useNavigate()

    const [slideImages, setSlideImages] = useState([]);
    const [pinProducts, setPinProducts] = useState([]);
    const [highligthProducts, setHighlightProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingPin, setIsLoadingPin] = useState(true);
    const [isLoadingHighlight, setIsLoadingHighlight] = useState(true);

    const [searchValue, setSearchValue] = useState("")

    function getSlideImages() {
        setIsLoading(true)
        getList(slide_images).then((response) => {
            setSlideImages(response.data)
            setIsLoading(false)

        }).catch((err) => {
            setSlideImages([])
        })
    }

    function getPinProducts() {
        setIsLoadingPin(true)
        getList(pin_products).then((response) => {
            setPinProducts(response.data)
            setTimeout(() => {
                setIsLoadingPin(false)
            }, 500);
        }).catch((err) => {
            setPinProducts([])
        })
    }

    function getHighlightProducts() {
        setIsLoading(true)
        getList(highlight_products).then((response) => {
            setHighlightProducts(response.data)
            setTimeout(() => {
                setIsLoadingHighlight(false)
            }, 500);
        }).catch((err) => {
            setHighlightProducts([])
        })
    }

    useEffect(() => {
        getSlideImages();
        getPinProducts();
        getHighlightProducts();
    }, []);

    function onSearch() {
        navigate(`/products?search=${searchValue}`)
    }

    return (
        <div>
            <div className='home-container' style={{ gridTemplateColumns: isLoading || slideImages?.length > 0 ? "50% 50%" : "100%" }}>
                <div style={leftSectionStyle}>
                    <h1 style={{ fontSize: "clamp(20px,2.5vw,26px)", color: '#333', marginBottom: '5px', marginTop: 0 }}>
                        เราคือผู้ผลิตและออกแบบ สินค้าพรีเมี่ยม Corporate Gift ของพรีเมี่ยม ของแถม ของแจก ของชำร่วย สินค้าที่ระลึก สินค้าแจกพนักงาน และ ลูกค้า ที่มีประสบการณ์โดยตรงมามากกว่า 20 ปี
                    </h1>
                    <p style={{ fontSize: '15px', color: '#fd0088', marginTop: 5 }}>
                        มีประสบการณ์จัดหาและผลิตสินค้าพรีเมี่ยม ให้กับบริษัทชั้นนำมากมาย
                        <br />
                        เชิญชมสินค้าของเราได้ สนใจติดต่อ 081-845-2288, 02-891-3300
                    </p>
                    <div style={{ fontSize: "clamp(20px,2.5vw,26px)", position: "relative", zIndex: 1, marginTop: 0 }}>
                        <SearchOutlined style={{ position: "absolute", top: '28%', right: 20, fontSize: 24, color: '#fd0088', zIndex: 1 }} />
                        <Input
                            onChange={(e) => setSearchValue(e.target.value)}
                            onPressEnter={onSearch}
                            type="text"
                            placeholder="ค้นหาสินค้าทั้งหมด"
                            style={inputStyle} />
                    </div>

                    <div style={{ display: "flex", gap: 10, width: "100%", alignItems: "center", whiteSpace: "nowrap" }}>
                        <h1 style={{ fontSize: "clamp(20px,2.5vw,26px)", marginBottom: 0 }}>สอบถามสินค้าพรีเมี่ยม ที่นี่</h1>
                        <img width={30} height={30} src={DownFinger} alt="Down arrow" style={{ transform: "rotate(180deg)", marginTop: 15 }} />
                    </div>
                    <div className="socialIconStyle" style={{ display: "flex", gap: 10, width: "100%" }}>
                        <LineButton width={'100%'} height={50} />
                        <FacebookButton width={'100%'} height={50} />
                    </div>
                </div>
                {isLoading ? (
                    <Loading description={'กำลังโหลดภาพสไลด์'} />
                ) : slideImages.length > 0 &&
                <div style={rightSectionStyle}>

                    <Carousel autoplay>
                        {slideImages.map((image, index) => (
                            <div key={index}>
                                <img
                                    src={image.images[0]}
                                    alt={`slide-${index}`}
                                    style={{ width: '100%', }}
                                />
                            </div>
                        ))}
                    </Carousel>
                </div>}
            </div>

            <div className='home-titleContainer'>
                <h1 style={{ fontSize: 34, margin: 0 }}>สินค้าแนะนำ</h1>
                <p style={linkStyle} onClick={() => navigate('/products')}>
                    ดูทั้งหมด
                </p>
            </div>
            {isLoadingPin ? (
                <Loading description={'กำลังโหลดสินค้าแนะนำ'} />
            ) : (
                <div className='home-pinContainer'>
                    {pinProducts.length > 0 ? pinProducts?.map((product, i) => (
                        <ProductCard
                            key={i}
                            name={product.name}
                            description={product.detail}
                            image={product.images[0]}
                            navigate_to={`/products/${product.category_id}/${product.tag_id}/${product.id}`}
                        />
                    )) : <Empty />}
                </div>
            )}

            <div className='home-titleContainer'>
                <h1 style={{ fontSize: 34, margin: 0 }}>สินค้าอินเทรนด์</h1>
                <p style={linkStyle} onClick={() => navigate('/products')}>
                    ดูทั้งหมด
                </p>
            </div>
            {isLoadingHighlight ? (
                <Loading description={'กำลังโหลดสินค้าอินเทรนด์'} />
            ) : (

                <div className='home-pinContainer'>
                    {highligthProducts.length > 0 ? highligthProducts?.map((product, i) => <ProductCard key={i} name={product.name} description={product.detail} image={product.images[0]} navigate_to={`/products/${product.category_id}/${product.tag_id}/${product.id}`} />) : <Empty />}
                </div>
            )}
        </div>
    );
}